import * as adminActionTypes from './adminActionTypes';

const initialState = {
    user: null,
    jwtToken: null,
    isLoading: false,
    error: null,
    uploadingDataLoader: false,
    publishingLoader: false,
    errors: null,
    importedData: [],
    errorData: [],
    errorMsg: '',
    updatedData: [],
    errorPublishedData: [],
    adminSports: [],
};

const applicationReducer = (state = initialState, action) => {
    switch (action.type) {
        case adminActionTypes.START_LOGIN_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
            return {
                ...state,
                isLoading: false,
                error: null,
            };
        case adminActionTypes.START_LOGIN_REQUEST_SUCCEEDED:
        case adminActionTypes.STORE_LOGIN_RESPONSE:
            return {
                ...state,
                user: {
                    name: action.payload.response.user?.username || '',
                    email: action.payload.response.user?.email || '',
                    id: action.payload.response.user?.id || '',
                },
                jwtToken: action.payload.response?.jwt || '',
                isLoading: false,
                error: null,
            };
        case adminActionTypes.SAVED:
            return {
                ...state,
                jwtToken: action.payload.jwtToken,
                isLoading: false,
                error: null,
            };
        case `${adminActionTypes.START_LOGIN_REQUEST}_FAILED`:
            return {
                ...state,
                user: null,
                isLoading: false,
                error: typeof action.error === 'string' ? action.error
                    : action.error?.message || 'Login failed',
            };
        case adminActionTypes.LOGOUT:
            return {
                ...initialState,
            };
        case adminActionTypes.IMPORT_DATA_REQUEST:
        case adminActionTypes.IMPORT_DATA_REQUEST_SENT:
            return {
                ...state,
                errors: null,
                importedData: [],
                updatedData: [],
                errorData: [],
                isLoading: true,
            };

        case adminActionTypes.IMPORT_DATA_REQUEST_SUCCEEDED:
            const {updatedData, errors} = action.payload.response;
            return {
                ...state,
                errors: errors,
                importedData: updatedData,
                isLoading: false,
            };

        case adminActionTypes.IMPORT_DATA_ERROR:
        case adminActionTypes.IMPORT_DATA_REQUEST_FAILED:
            return {
                ...state,
                error: true,
                isLoading: false,
            };

        case adminActionTypes.PUBLISH_DATA_REQUEST_SENT:
            return {
                ...state,
                updatedData: [],
                importedData: [],
                isLoading: true,
            };

        case adminActionTypes.PUBLISH_DATA_SUCCEED:
        case adminActionTypes.PUBLISH_DATA_REQUEST_SUCCEEDED:
            return {
                ...state,
                isLoading: false,
                ...action.payload.response,
            };
        case adminActionTypes.PUBLISH_DATA_ERROR:
            return {
                ...state,
            };
        case adminActionTypes.SET_UPLOADING_DATA_LOADER:
            return {
                ...state,
                isLoading: true,
            };
        case adminActionTypes.SET_ERRORS:
            return {
                ...state,
                errorMsg: action.payload,
            };

        case adminActionTypes.SET_IMPORTED_DATA:
            return {
                ...state,
                importedData: action.payload,
            };

        case adminActionTypes.SET_ERROR_DATA:
            return {
                ...state,
                errorData: action.payload,
            };

        case adminActionTypes.SET_PUBLISHED_DATA:
            return {
                ...state,
                publishedData: action.payload,
            };

        case adminActionTypes.SET_ERROR_PUBLISHED_DATA:
            return {
                ...state,
                errorPublishedData: action.payload,
            };

        case adminActionTypes.SET_JWT_TOKEN:
            return {
                ...state,
                jwtToken: action.payload,
            };
        case adminActionTypes.STORE_ADMIN_SPORTS:
            console.log(action.payload, 'ACTIONNNN');
            return {
                ...state,
                adminSports: action.payload.sportDTOs.allSports.sports,
            };
        default:
            return state;
    }
};

export default applicationReducer;
